export const ASSISTANT_SERVICE_HOST = 'https://wims-assistant.winglegroup.com';

export const ASSISTANT_PATHS = {
  assistant: `${ASSISTANT_SERVICE_HOST}/api/assistant`,
  runAssistant: `${ASSISTANT_SERVICE_HOST}/api/run-assistant`,
  assistantDifferences: `${ASSISTANT_SERVICE_HOST}/api/assistant/product`,
  assistantDifferenceSuffix: '/differences',
  assistantPrompt: `${ASSISTANT_SERVICE_HOST}/api/assistant/prompt`,
  assistantDeclineSuffix: '/decline',
  assistantClone: `${ASSISTANT_SERVICE_HOST}/api/assistant/clone`,
  assistantExtractSuffix: `${ASSISTANT_SERVICE_HOST}/api/assistant/extract_suffix`,
  assistantInsightsSuffix: '/insights',
  assistantCommentSuffix: '/comment',
};
